import { render, staticRenderFns } from "./ToDoList.vue?vue&type=template&id=2a41852c"
import script from "./ToDoList.vue?vue&type=script&lang=js"
export * from "./ToDoList.vue?vue&type=script&lang=js"
import style0 from "./ToDoList.vue?vue&type=style&index=0&id=2a41852c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports